import { useState } from "react"
import ModalCodigoSMS from "./ModalCodigoSMS"

const PolizaCards = () => {

    const [mostrarModalCodigoSMS, setMostrarModalCodigoSMS] = useState(false)

    return (
        <>
            <ModalCodigoSMS
                show={mostrarModalCodigoSMS}
                close={setMostrarModalCodigoSMS}
            />
            
            <section className='pol__cards-in'>
                <div className="poliza__cards-in">
                    <div className="pol__card">
                        <div>
                            <div className='pol__card-img'>
                                <img className='pol__card-icoprincipal' src='/assets/img/homein/poliza/img-poliza.png' alt="imagen cob" />
                                <div className='pol__card-ico_container ' >
                                    <img className={`pol__card-ico`} style={{ width: '60px', height: '60px' }} src='/assets/img/homein/poliza/ico-poliza.svg' alt="imagen cob icono" />
                                </div>
                            </div>
                            <div className="pol__card-texto">
                                <div className="pol__card-superior">
                                    <h4 style={{ textAlign: 'center', marginBottom: '1em' }} className={`pol__card-title`}>Consulta tu póliza</h4>
                                    <p style={{ fontSize: '1.6rem', lineHeight: '20px' }} className='pol__card-descripcion'>Tu póliza es el documento más importante de tu seguro, tenerla protegida y al alcance nunca había sido tan sencillo.</p>
                                </div>
                            </div>
                        </div>
                        <div className="pol__card-btn" >
                            <div
                                className='btn__azul'
                                onClick={() => setMostrarModalCodigoSMS(true)}
                            >
                                CONSULTAR
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default PolizaCards